export default __webpack_public_path__ + "static/media/upsell-puzzle.d2a6eaac.png";